<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-text-input
        controlName="insurerId"
        placeholder="IN-00-0000-000"
        [maskConfig]="inIdMaskConfig"
      ></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-search-type-group">
        <app-select-input
          class="form-search-type-select"
          #nameSearchOptionTypeList
          controlName="nameSearchOptionType"
          [showNullPlaceholder]="false"
        ></app-select-input>
        <app-generic-input
          class="form-search-type-input"
          approvedNameCharacters
          controlName="insurerName"
        ></app-generic-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-text-input
        #feinTemplate
        controlName="fein"
        [maskConfig]="feinMaskConfig"
        (input)="onFeinChange()"
      ></app-text-input>
    </div>
    <div class="col-6">
      <app-generic-input controlName="insurerNumber"></app-generic-input>
    </div>
  </div>
</form>
